import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import {
  AchievementOverview,
  AchievementOverviewParams,
  PersonAchievement
} from '@/types/achievement';
import PaginatedResponse from '@/types/paginatedResponse';
import ajax from '@/utils/ajax';

export const achievementRepository = {
  async getOverview({
    host,
    params,
    personId
  }: {
    host: string;
    params: AchievementOverviewParams;
    personId: string;
  }): Promise<PaginatedResponse<AchievementOverview[]>> {
    try {
      const path = `/api/dugout/person/achievements/overview/?person_id=${personId}`;
      const response = await ajax.get({
        params: {
          ...params
        },
        url: `${host}${path}`
      });

      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createPersonAchievement({
    host,
    data
  }: {
    host: string;
    data: PersonAchievement;
  }): Promise<PersonAchievement> {
    try {
      const path = `/api/dugout/person/achievements/`;
      const response = await ajax.post({
        data: {
          ...data
        },
        url: `${host}${path}`
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

const AchievementRepository = () => {
  const { host } = useContext(AppContext);
  return {
    async getOverview(
      params: AchievementOverviewParams,
      personId: string
    ): Promise<PaginatedResponse<AchievementOverview[]>> {
      return achievementRepository.getOverview({ host, params, personId });
    },
    async createPersonAchievement(data: PersonAchievement): Promise<PersonAchievement> {
      return achievementRepository.createPersonAchievement({ host, data });
    }
  };
};

export default AchievementRepository;
